import { useTranslation } from 'react-i18next';
import {
  ElementsButton,
  SideOverHeading,
  SideOverHeaderNew,
  SideOverHeaderNewProps,
  SideOverFooter,
} from '../components';
import {
  StandardPersonalPropertyItemForm,
  StandardPersonalPropertyItemFormVisibilityOptions,
} from '../../PersonalPropertyItem/components';
import { usePersonalPropertyItemForm } from '../../PersonalPropertyItem/hooks';

export interface EditPersonalPropertyItemFormSideOverPageProps extends Pick<SideOverHeaderNewProps, 'exit'> {
  firmID: string;
  clientID: string;
  visibilityOptions?: StandardPersonalPropertyItemFormVisibilityOptions;
  isLoading?: boolean;
  sideOverHeaderChildren?: React.ReactNode;
  usePersonalPropertyItemFormReturn: ReturnType<typeof usePersonalPropertyItemForm>;
}

export function EditPersonalPropertyItemFormSideOverPage({
  exit,
  firmID,
  clientID,
  isLoading,
  visibilityOptions,
  sideOverHeaderChildren,
  usePersonalPropertyItemFormReturn,
}: EditPersonalPropertyItemFormSideOverPageProps) {
  const { t: tCommon } = useTranslation('common');

  return (
    <>
      <SideOverHeaderNew exit={exit} withShadow className="!px-4" exitText={tCommon('cancel')}>
        {sideOverHeaderChildren}
      </SideOverHeaderNew>
      <div className="px-10">
        <SideOverHeading className="!mt-[25px] mb-14" heading={tCommon('personal-property-item')} />
        <StandardPersonalPropertyItemForm
          firmID={firmID}
          clientID={clientID}
          className="mb-36"
          visibilityOptions={visibilityOptions}
          usePersonalPropertyItemFormReturn={usePersonalPropertyItemFormReturn}
        >
          <SideOverFooter>
            <ElementsButton
              size="large"
              icon="check"
              iconPosition="left"
              isLoading={isLoading}
              label={tCommon('save')}
            />
          </SideOverFooter>
        </StandardPersonalPropertyItemForm>
      </div>
    </>
  );
}
